import mapboxgl from 'mapbox-gl';
import MultiTouch from 'mapbox-gl-multitouch';
import $ from 'jquery';

const MapFlyover = {
    bindEvents: () => {
        const mapHomepage = document.getElementById('mapboxGL');
        if (mapHomepage) {
            MapFlyover.init();
            MapFlyover.zoom();
        }

        const mapGeneral = document.getElementById('mapboxGeneral');
        if (mapGeneral) {
            MapFlyover.generalMap(mapGeneral);
        }
    },
    generalMap: (mapGeneral) => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiYm9iYnlqbSIsImEiOiJjamszMmZkN28wMmJtM2ttZW8wOWRhZGFmIn0.mg4MrZq0kRGaFBfcnx-1-g';
        // MapFlyover.map = new mapboxgl.Map({
        //     container: 'mapboxGeneral',
        //     style: 'mapbox://styles/mapbox/satellite-v9',
        //     center: [
        //         mapGeneral.getAttribute('data-long'),
        //         mapGeneral.getAttribute('data-lat')
        //     ], // starting position
        //     zoom: mapGeneral.getAttribute('data-zoom') // starting zoom
        // });
        // MapFlyover.map.scrollZoom.disable();
        // MapFlyover.map.addControl(new mapboxgl.NavigationControl());
        // const marker = new mapboxgl.Marker()
        //     .setLngLat([
        //         mapGeneral.getAttribute('data-long'), mapGeneral.getAttribute('data-lat')
        //     ])
        //     .addTo(MapFlyover.map);

        let map = new mapboxgl.Map({
            container: "mapboxGeneral",
            style: 'mapbox://styles/mapbox/satellite-v9',
            zoom: mapGeneral.getAttribute('data-zoom'),
            center: [
                mapGeneral.getAttribute('data-long'), mapGeneral.getAttribute('data-lat')
            ]
        });

        map.on('load', function () {
            /* Image: An image is loaded and added to the map. */
            map.loadImage(mapGeneral.getAttribute('data-marker'), function(error, image) {
                if (error) throw error;
                map.addImage("custom-marker", image);
                /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
                map.addLayer({
                    id: "markers",
                    type: "symbol",
                    /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
                    source: {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features:[
                                {
                                    "type": "Feature",
                                    "geometry": {
                                        "type":"Point",
                                        "coordinates":[
                                            mapGeneral.getAttribute('data-long'), mapGeneral.getAttribute('data-lat')
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    layout: {
                        "icon-image": "custom-marker",
                    }
                });
            });
        });
        MapFlyover.map = map;
        MapFlyover.map.scrollZoom.disable();
        MapFlyover.map.addControl(new mapboxgl.NavigationControl());
        MapFlyover.map.addControl(new MultiTouch());
    },
    init: () => {

        mapboxgl.accessToken = 'pk.eyJ1IjoiYm9iYnlqbSIsImEiOiJjamszMmZkN28wMmJtM2ttZW8wOWRhZGFmIn0.mg4MrZq0kRGaFBfcnx-1-g';
        MapFlyover.map = new mapboxgl.Map({
            container: 'mapboxGL',
            style: 'mapbox://styles/mapbox/satellite-v9',
            center: [174.7581673, -36.8490933], // starting position
            zoom: 17, // starting zoom
            boxZoom: false
        });

        MapFlyover.map.addControl(new mapboxgl.NavigationControl());

        // Show markers only on certain zoom
        MapFlyover.map.on('zoomend', function (e) {
        });

        MapFlyover.map.scrollZoom.disable();
    },
    mapboxFly: (level) => {

        MapFlyover.map.flyTo({
            curve: 2,
            bearing: 0,
            speed: 0.3,
            center: [level.lat, level.long],
            zoom: level.zoom
        });

        MapFlyover.map.once('moveend', function () {
            $('#mapTitle').html(level.title);
            $('.spanContent').html(level.content);
            $('.spanContent').fadeIn();
        });
    },
    zoom: () => {

        const mapPoints = [
            {
                'title': 'The Center',
                'lat': 174.7581673,
                'long': -36.8490933,
                'zoom': 17,
                'content': 'The NZICC is centrally located in Auckland’s central business district.\n' +
                'Surrounded by key business event infrastructure within a n easy walk, such as universities, business hubs, innovation precincts, over 6,000 hotel rooms, entertainment precincts and tourist amenities.'
            },
            {
                'title': 'Auckland',
                'lat': 174.7581673,
                'long': -36.8490933,
                'zoom': 11,
                'content': 'Auckland is a thriving hub in the Asia Pacific, consistently rated as one of the best places in the world to live, work and study in.'
            },
            {
                'title': 'New Zealand',
                'lat': 173.283966,
                'long': -41.270634,
                'zoom': 5,
                'content': 'New Zealand is a unique mix of Maori, European and Asian cultures, grown by a rich and fascinating history. New Zealanders are known for their warm hospitality making it a wonderful place to host international events.'
            }
        ];

        const zoomButtons = document.getElementsByClassName('sib-map-flyover__zoom');
        for (let i = 0; i < zoomButtons.length; i++) {
            zoomButtons[i].addEventListener('click', (e) => {
                e.preventDefault();
                const mapGL = document.getElementById('mapboxGL');
                const content = document.getElementById('flyover-content');
                const title = document.getElementById('flyover-content');
                const zoomIn = document.getElementById('sib-map-flyover__zoomin');
                const zoomOut = document.getElementById('sib-map-flyover__zoomout');
                let level = mapGL.getAttribute('data-level');
                console.log(level);

                $('.spanContent').fadeOut(function(){
                    $('#mapContent').removeClass('sib-map-flyover__content--level-' + level);
                    if (zoomButtons[i].getAttribute('data-zoom') === 'out') {
                        level++;
                    } else {
                        level--;
                    }
                    $('#mapContent').addClass('sib-map-flyover__content--level-' + level)
                    if (level === 0) {
                        console.log(level);
                        $('#sib-map-flyover__zoomin').fadeOut();

                        MapFlyover.map.once('moveend', function () {
                            $('#sib-map-flyover__image').fadeIn();

                        });
                    }
                    if (level === 1) {
                        console.log(level);
                        $('#sib-map-flyover__image').fadeOut();
                        $('#sib-map-flyover__zoomin').fadeIn();
                        $('#sib-map-flyover__zoomout').fadeIn();
                    }
                    if (level === 2) {
                        $('#sib-map-flyover__zoomout').fadeOut();
                    }
                    zoomIn.style.backgroundImage = `url("/web/images/level${level - 1}.png")`;
                    zoomOut.style.backgroundImage = `url("/web/images/level${level + 1 }.png")`;
                    zoomIn.style.display = `flex`;
                    zoomOut.style.display = `flex`;
                    console.log(level);
                    mapGL.setAttribute('data-level', level);
                    MapFlyover.mapboxFly(mapPoints[level]);
                });
            });
        }
    }
};

module.exports = MapFlyover;



// WEBPACK FOOTER //
// ./src/js/partials/mapboxgl.js